import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1040Status: 'idle',
    startProcess1040Error: undefined as any,
    loadUserParamsProcess1040Status: 'idle',
    loadUserParamsProcess1040Error: undefined as any,

    process1040List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1040 = createAsyncThunk('process1040Slice/startProcess1040', async ({ process1040 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1040/`,
        prepareData(process1040),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1040Status } = getState().process1040Slice
        return startProcess1040Status !== 'pending'
    }
})

export const loadUserParamsProcess1040 = createAsyncThunk('process1040Slice/loadUserParamsProcess1040', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1040/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1040Status } = getState().process1040Slice
        return loadUserParamsProcess1040Status !== 'pending'
    }
})

const Process1040Slice = createSlice({
    name: 'process1040Slice',
    initialState,
    reducers: {
        resetstartProcess1040: (state) => {
            state.job = undefined
            state.startProcess1040Error = undefined
        },
        resetstartProcess1040Error: (state) => {
            state.startProcess1040Error = undefined
        },
        resetloadUserParamsProcess1040: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1040Error = undefined
        },
        resetloadUserParamsProcess1040Error: (state) => {
            state.loadUserParamsProcess1040Error = undefined
        },
        removeFromProcess1040ListById: (state, action) => {
            state.process1040List = state.process1040List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1040ListByIds: (state, action) => {
            state.process1040List = state.process1040List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1040List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1040Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1040List = []
            state.startProcess1040Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1040.pending, (state) => {
            state.startProcess1040Status = 'pending'
            state.startProcess1040Error = undefined
        })
        builder.addCase(startProcess1040.fulfilled, (state, action) => {
            state.startProcess1040Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1040.rejected, (state, action) => {
            state.startProcess1040Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1040Error = action.error.message
            } else {
                state.startProcess1040Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1040.pending, (state) => {
            state.loadUserParamsProcess1040Status = 'pending'
            state.loadUserParamsProcess1040Error = undefined
        })
        builder.addCase(loadUserParamsProcess1040.fulfilled, (state, action) => {
            state.loadUserParamsProcess1040Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1040.rejected, (state, action) => {
            state.loadUserParamsProcess1040Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1040Error = action.error.message
            } else {
                state.loadUserParamsProcess1040Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1040,
    resetstartProcess1040Error,
    resetloadUserParamsProcess1040,
    resetloadUserParamsProcess1040Error,
    removeFromProcess1040ListById,
    removeFromProcess1040ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1040Slice.actions
export default Process1040Slice.reducer
